import Clinic, { ClinicLaboratoryModel } from "../../models/clinic";

export function sortClinicsByDistance(a: Clinic, b: Clinic): number {
    if (a.distanceInMeters === null && b.distanceInMeters === null) {
        return 0;
    }
    if (a.distanceInMeters === null) return 1;
    if (b.distanceInMeters === null) return -1;

    return a.distanceInMeters - b.distanceInMeters;
}

export function sortClinicsByNextAvailableTime(a: Clinic, b: Clinic): number {
    if (!a?.nextAvailableTime && !b?.nextAvailableTime) {
        // Always put items missing nextAvailableTime last
        return 0;
    }
    if (!a?.nextAvailableTime) return 1;
    if (!b?.nextAvailableTime) return -1;

    return (
        new Date(a.nextAvailableTime).getTime() -
        new Date(b.nextAvailableTime).getTime()
    );
}

export function sortClinicsByDefaultOrder(a: Clinic, b: Clinic): number {
    // Francis asked to deploy a quick solution for the Clinic sorting
    // He wants a specific order for the clinics
    // I created a ticket to clean this up afterward and improve the way we handle this
    // GEN-427 - https://www.notion.so/prelib/Patient-Portal-Improve-Clinic-list-sorting-1c2186789a8f8070bf95e636f51b9195

    const clinicOrder = [
        { name: "Crescent", isPrivate: false },
        { name: "Berri", isPrivate: false },
        { name: "Clinique L'Agora", isPrivate: false },
        { name: "Saint Laurent", isPrivate: true },
        { name: "Crescent", isPrivate: true },
        { name: "Berri", isPrivate: true },
        { name: "Québec - Ste-Foy", isPrivate: false },
        { name: "Ville de Sherbrooke", isPrivate: false },
    ];

    const aIsPrivate = a.laboratoryModel === ClinicLaboratoryModel.Private;
    const bIsPrivate = b.laboratoryModel === ClinicLaboratoryModel.Private;

    let aIndex = -1;
    let bIndex = -1;

    for (let i = 0; i < clinicOrder.length; i++) {
        const orderItem = clinicOrder[i];

        if (
            a.name.includes(orderItem.name) &&
            aIsPrivate === orderItem.isPrivate &&
            aIndex === -1
        ) {
            aIndex = i;
        }

        if (
            b.name.includes(orderItem.name) &&
            bIsPrivate === orderItem.isPrivate &&
            bIndex === -1
        ) {
            bIndex = i;
        }
    }

    if (aIndex !== -1 && bIndex !== -1) {
        return aIndex - bIndex;
    }

    if (aIndex !== -1) return -1;
    if (bIndex !== -1) return 1;

    return a.name.localeCompare(b.name);
}
